<div class="notifications-view" ui-view ng-controller="notificationsController as noteCtrl">
    <h1>{{'admin.notifications'|translate}}</h1>

    <ul class="notifications-widgets">
        <li ng-click="noteCtrl.goto('admin.notificationtemplates')"><span>{{'admin.configuration.notificationTemplates'|translate}}</span></li>
        <li ng-click="noteCtrl.goto('admin.notificationfooters')"><span>{{'admin.configuration.notificationFooters'|translate}}</span></li>
    </ul>
</div>